import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import AccountRoutingRulesFormHandle from '../containers/forms/cardHolders/AccountRoutingRulesFormHandle';
import CommissionSettingsFormHandle from '../containers/forms/cardHolders/CommissionSettingsFormHandle';
import PersonalizationSettingsFormHandle from '../containers/forms/cardHolders/PersonalizationSettingsFormHandle';
import PrintOutputFormattingFormHandle from '../containers/forms/cardHolders/PrintOutputFormattingFormHandle';

const CardHolders = () => {
  return (
    <div>
    <CC.Tabs>
      <div style={{overflowX: "auto"}}>
      <CC.TabList>
        <CC.Tab minWidth={'fit-content'}>Account Routing Rules</CC.Tab>
        <CC.Tab minWidth={'fit-content'}>Commission Parameters</CC.Tab>
        <CC.Tab minWidth={'fit-content'}>Personnalization Parameters</CC.Tab>
        <CC.Tab minWidth={'fit-content'}>Print Output Formatting</CC.Tab>
      </CC.TabList>
      </div>

      <CC.TabPanels>
        <CC.TabPanel>
          <AccountRoutingRulesFormHandle />
        </CC.TabPanel>
        <CC.TabPanel>
          <CommissionSettingsFormHandle />
        </CC.TabPanel>
        <CC.TabPanel>
          <PersonalizationSettingsFormHandle />
        </CC.TabPanel>
        <CC.TabPanel>
          <PrintOutputFormattingFormHandle />
        </CC.TabPanel>
      </CC.TabPanels>
    </CC.Tabs>

    </div>
  )
}

export default CardHolders;